var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list-tile',{on:{"click":function($event){return _vm.$emit('baixar')}}},[_c('v-list-tile-title',[_c('i',{staticClass:"fas fa-download mr-2",attrs:{"aria-hidden":"true"}}),_vm._v(" Relatório Mais Brasil ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }